import TrainingGroup from './ListGroups';
export default TrainingGroup;
